module.exports = __webpack_public_path__ + "components/snow-conditions/static/watermark-0d6ccb55e629c2e4a5242b29148a9051.svg";